/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import type { WebPushOptInCopy } from './types';

export const defaultWebPushOptInCopy: WebPushOptInCopy = {
  title: 'This website would like to send you updates and offers.',
  body: 'Notifications can be turned off anytime from your browser settings.',
  allowLabel: 'Allow',
  dismissLabel: 'Don’t allow',
};
